// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__29-wY","inputDescription":"styles_inputDescription__v_csy"};